// The file contents for the current environment will overwrite these during
// build. The build system defaults to the dev environment which uses
// 'environment.ts', but if you do 'ng build --env=prod' then
// 'environment.prod.ts' will be used instead. The list of which env maps to
// which file can be found in '.angular-cli.json'.

export const environment = {
  production: false,
  baseAPIUrl: '',
  apiServer: '',
  dossier: '/api/Dossier/',
  neuesDossier: '/api/NeuesDossier/',
  feedback: '/api/Feedback/',
  fieldTypeOperators: './assets/operators.json',
  trefferListe: 'api/Stoffliste',
  supportedUILanguages: [
    { Title: 'Deutsch', CultureCode: 'de' },
    { Title: 'English', CultureCode: 'en' },
  ],
  supportedUIUserLanguages: [
    { Title: 'Deutsch', CultureCode: 'de-DE' },
    { Title: 'English', CultureCode: 'en-GB' },
  ],
  defaultUIUserCulture: 'de-DE',
  batchNeueSachverhalte: '/api/batch/NeueSachverhalte',
  batchGesperrteMerkmale: '/api/batch/GesperrteMerkmale',
  batchErfassungen: '/api/batch/Erfassungen',
  batchLoescheDossiers: '/api/batch/LoescheDossiers',
  citation: '/api/Zitat/',
  // User Management
  userManagementUrl: '',
  changePasswordUrl: '',
  manageUserUrl: '',
  dataModelEditorUrl: '',
  rechercheUrl: '',
  version: '5.2.0',
  maxAllowedImportSizeInMB: 25,
  tableStateMaxAgeInSeconds: null,
};
